/**
  * 大屏选择自动播放的定位点出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const bigmap = {
    // 下拉列表
    allLocations(params) {
        return axios.get(api + 'bigmap/allLocations', { params: params })
    },
    //所有已选择的定位点
    hotLocations(params) {
        return axios.get(api + 'bigmap/hotLocations', { params: params })
    },
    // 添加
    posthotlocation(params) {
        return axios.post(api + 'bigmap/posthotlocation', qs.stringify(params))
    },
    // 删除
    remove(params) {
        return axios.post(api + 'bigmap/remove', qs.stringify(params))
    },
    //获取资讯数量
    getZixun(params) {
        return axios.get(api + 'bigmap/getZixun', { params: params })
    },
    // 更新资讯数量
    postZixun(params) {
        return axios.post(api + 'bigmap/postZixun', qs.stringify(params))
    },
    //获取一选择的热度地区
    getHeatArea(params) {
        return axios.get(api + 'bigmap/getHeatArea', { params: params })
    },
    getHeatAreaDetail(params) {
        return axios.get(api + 'bigmap/getHeatAreaDetail', { params: params })
    },
    // 选择热度地区
    postHeatArea(params) {
        return axios.post(api + 'bigmap/postHeatArea', qs.stringify(params))
    },
    // 更新假数据
    postHeatAreaNum(params) {
        return axios.post(api + 'bigmap/postHeatAreaNum', qs.stringify(params))
    },
    // 删除热度地区
    removeHeatArea(params) {
        return axios.post(api + 'bigmap/removeHeatArea', qs.stringify(params))
    },
}

// 导出接口
export default bigmap
